module.exports = __webpack_public_path__ + "img/feedSucess.259a9a40.svg";